import { Avatar, Collapse, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { getTableTimestamp } from 'src/common/utils'
import { useMe } from 'src/hooks'
import { IMediaListItem } from 'src/types'
import { LinkCell } from '../media-table/cells'

import { useStyles } from './styles'

interface IProps {
  open: boolean
  item: IMediaListItem
}

const GridItemCollapse = ({ open, item }: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const { data: user } = useMe()

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="div" className={classes.collapseItemsWrapper}>
        <ListItem disablePadding>
          <ListItemText
            primary={t('connection-table-column.v') + ':'}
            secondary={
              item.connection ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {item.connection.image && (
                    <ListItemAvatar>
                      <Avatar
                        src={item.connection.image_small || item.connection.image}
                        alt={item.connection.title}
                      />
                    </ListItemAvatar>
                  )}
                  <ListItemText
                    primary={item.connection?.title}
                    secondary={item.connection.type.replace('_', ' ')}
                  />
                </div>
              ) : (
                '-'
              )
            }
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemText
            primary={t('medial-link-table-column.v') + ':'}
            secondary={
              <LinkCell
                id={item.id}
                link={item.link}
                small={item.link_small}
                medium={item.link_medium}
                large={item.link_large}
                width={Number(item.dimensions?.split('x')[0])}
                height={Number(item.dimensions?.split('x')[1])}
                size={item.size}
                size_large={item.size_large}
                size_medium={item.size_medium}
                size_small={item.size_small}
              />
            }
          />
        </ListItem>
        <ListItem disablePadding>
          <ListItemText primary={t('media-type-table-column.v') + ':'} secondary={item.type} />
        </ListItem>
        <ListItem disablePadding>
          <ListItemText
            primary={t('table-created-column.v') + ':'}
            secondary={getTableTimestamp({ date: item.created_at, timezone: user?.timezone })}
          />
        </ListItem>
      </List>
    </Collapse>
  )
}

export { GridItemCollapse }
